import paketHistoryImg from "../../../assets/images/paketHistory.jpeg";
import paketHdesignImg from "../../../assets/images/PaketHdesign.jpg";
import paketOurs from "../../../assets/images/ourVisionGray.jpg";
import Icon1 from "../../../assets/images/icon1.svg";
import Icon2 from "../../../assets/images/icon2.svg";
import Icon3 from "../../../assets/images/icon3.svg";

const projectDatas = [
  {
    title: "Story of Paketposthalle",
    description: "Tracing its transformation from Logistics Landmark to Urban Icon.",
    image: paketHistoryImg,
    icon: Icon2,
  },
  {
    title: "Herzog & de Meuron’s Vision",
    description: "Discover the design approach by Herzog & de Meuron.",
    image: paketHdesignImg,
    icon: Icon1,
  },
  {
    title: "Reimagining Paketposthalle",
    description: "Alternative proposals that envision new possibilities.",
    image: paketOurs,
    icon: Icon3,
  },
];

export default projectDatas;
